import { Container } from "@material-ui/core";
import React from "react";
import { FooterStyles } from "./footer.styles";

export default function Footer() {
  const classes = FooterStyles();
  return (
    <Container className={classes.bottom}>
      <a href="mailto: support@mentorogroup.com" className={classes.help}>
        Help
      </a>
    </Container>
  );
}
